import React from "react";
import { Box, Typography } from "@mui/material";
import { engineTokens } from "../theme";

type Props = {
  step: number;
  title: string;
  helper?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
};

const StepSection = ({ step, title, helper, action, children }: Props) => {
  return (
    <Box
      sx={{
        border: `1px solid ${engineTokens.border}`,
        borderRadius: 2,
        p: 2,
        mb: 2,
        backgroundColor: engineTokens.bgPaper,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 1.5,
          mb: helper ? 1 : 1.5,
        }}
      >
        <Box
          sx={{
            width: 26,
            height: 26,
            borderRadius: "50%",
            backgroundColor: engineTokens.brand,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 13,
            fontWeight: 700,
            flexShrink: 0,
            mt: 0.25,
          }}
        >
          {step}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
            {title}
          </Typography>
          {helper && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {helper}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>
      <Box>{children}</Box>
    </Box>
  );
};

export default StepSection;
